import { render, staticRenderFns } from "./open-spreads-input.vue?vue&type=template&id=ec380702&"
import script from "./open-spreads-input.vue?vue&type=script&lang=js&"
export * from "./open-spreads-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports